import type { BaseAnchor, BaseVersion } from 'src/models/anchor-and-version/base.model';
import type { AnchorAndVersionBaseFilter } from 'src/filters/anchor-and-version-filter/anchor-and-version-base.filter';
import type { ModalProps } from '../../crud/crud-base-modal/modal-field.interface';
import { TreeType } from '../enums/tree-type.enum';

export interface AnchorService {
    CountAnchorsWithValidVersion(filter: AnchorAndVersionBaseFilter): Promise<number>;
    getAnchorsWithAllVersions(
        filter: AnchorAndVersionBaseFilter
    ): Promise<BaseAnchor<BaseVersion>[]>;
    getAnchorsWithValidVersion(
        filter: AnchorAndVersionBaseFilter
    ): Promise<BaseAnchor<BaseVersion>[]>;
}

export interface TreeModal {
    modalProps?: ModalProps;
    onClose?: () => void;
    onOpen?: () => void;
}

export type TreeModalMap = Partial<Record<TreeType, () => TreeModal | undefined>>;
export type TreeServiceMap = Partial<Record<TreeType, AnchorService>>;

export function createTreeModalMap(host: {
    addressModal?: TreeModal;
    allocationElementDiagramModal?: TreeModal;
    allocationElementModal?: TreeModal;
    componentCodeModal?: TreeModal;
    componentModal?: TreeModal;
    functionCategoryModal?: TreeModal;
    messageModal?: TreeModal;
    scenarioModal?: TreeModal;
    segmentModal?: TreeModal;
    signalModal?: TreeModal;
    useCaseModal?: TreeModal;
    userFunctionModal?: TreeModal;
}): TreeModalMap {
    return {
        [TreeType.Address]: () => host.addressModal,
        [TreeType.AllocationElementDiagram]: () => host.allocationElementDiagramModal,
        [TreeType.AllocationElement]: () => host.allocationElementModal,
        [TreeType.ComponentCode]: () => host.componentCodeModal,
        [TreeType.Component]: () => host.componentModal,
        [TreeType.FunctionCategory]: () => host.functionCategoryModal,
        [TreeType.Message]: () => host.messageModal,
        [TreeType.Scenario]: () => host.scenarioModal,
        [TreeType.Segment]: () => host.segmentModal,
        [TreeType.Signal]: () => host.signalModal,
        [TreeType.UseCase]: () => host.useCaseModal,
        [TreeType.UserFunction]: () => host.userFunctionModal,
    };
}

export function createTreeServiceMap(services: {
    addressService: AnchorService;
    allocationElementDiagramService: AnchorService;
    allocationElementService: AnchorService;
    canPortDataService: AnchorService;
    componentCodeService: AnchorService;
    componentService: AnchorService;
    directWirePortDataService: AnchorService;
    functionCategoryService: AnchorService;
    internalPortDataService: AnchorService;
    messageEntityService: AnchorService;
    scenarioService: AnchorService;
    segmentService: AnchorService;
    signalService: AnchorService;
    useCaseService: AnchorService;
    userFunctionService: AnchorService;
}): TreeServiceMap {
    return {
        [TreeType.Address]: services.addressService,
        [TreeType.AllocationElement]: services.allocationElementService,
        [TreeType.AllocationElementDiagram]: services.allocationElementDiagramService,
        [TreeType.CanPortData]: services.canPortDataService,
        [TreeType.Component]: services.componentService,
        [TreeType.ComponentCode]: services.componentCodeService,
        [TreeType.DirectWirePortData]: services.directWirePortDataService,
        [TreeType.FunctionCategory]: services.functionCategoryService,
        [TreeType.InternalPortData]: services.internalPortDataService,
        [TreeType.Message]: services.messageEntityService,
        [TreeType.Scenario]: services.scenarioService,
        [TreeType.Segment]: services.segmentService,
        [TreeType.Signal]: services.signalService,
        [TreeType.UseCase]: services.useCaseService,
        [TreeType.UserFunction]: services.userFunctionService,
    };
}
